import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const CatalogItemNriCreate = () => {
  return (
    <MicroFrontEnd
      name="CatalogItemNriCreate"
      src={apiConfig.microFrontEnds.CatalogItemNriCreate}
    />
  )
}

export default CatalogItemNriCreate
